import React from "react"
import TeamInterface from "../../interfaces/Team.interface"
import config from "../../config"
import { Link } from "react-router-dom"

const TeamListItem: React.FC<{ team: TeamInterface }> = ({ team }) => {
    return (
        <div className="flex items-center gap-5 border p-5">
            <img className="min-w-[75px] max-w-[75px] min-h-[75px] max-h-[75px] rounded-full" src={`${config.API_URL}/teams/${team?.id}/logo`} alt={`${team?.name}_logo`} />
            <div className="flex flex-col overflow-hidden">
                <Link className="text-lg font-bold text-zinc-700 hover:underline" to={`/teams/${team?.slug}`}>{team?.name}</Link>
                <p className="text-zinc-700 truncate">{team?.description}</p>
            </div>
        </div>
    )
}

export default TeamListItem